import { Loader } from 'components/Loader';
import React, { useState } from 'react';
import BeneficiaryDetails from 'components/BeneficiaryDetails';
import { useGetPhysicalAssetList } from 'common/queries-and-mutations/physical-asset';
import PhysicalAsset from 'components/Cards/AssetsCards/PhysicalAsset';

export default function PhysicalBeneficiaries() {
  const [selectedAssetId, setSelectedAssetId] = useState<number | undefined>(
    undefined
  );
  const { data, isLoading } = useGetPhysicalAssetList();

  const handleShowDetails = (assetId: number) => {
    setSelectedAssetId(selectedAssetId === assetId ? undefined : assetId);
  };

  return (
    <div>
      {isLoading ? (
        <div className="mt-40 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <>
          {data?.map(asset => {
            return (
              <div
                className="mt-1 w-full rounded-md bg-white shadow-sm"
                key={asset.id}
              >
                <PhysicalAsset
                  asset={asset}
                  selectedAssetId={selectedAssetId}
                  handleShowDetails={() => handleShowDetails(asset.id!)}
                />

                {selectedAssetId === asset.id && (
                  <div className="mt-2 border-t">
                    {asset.totalBeneficiary > 0 ? (
                      <>
                        <p className="px-6 py-5 text-base font-semibold text-[#34475E]">
                          Beneficiaries
                        </p>
                        <div className="px-3 pb-6">
                          {asset.totalBeneficiary > 0
                            ? asset.allocations.map(allocation => (
                                <BeneficiaryDetails
                                  key={allocation.id}
                                  allocation={allocation}
                                />
                              ))
                            : null}
                        </div>
                      </>
                    ) : (
                      <div className="flex items-center justify-center py-32 font-circular text-[#34475E]">
                        No Beneficiary Assigned
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}
